import { isEqual } from "lodash";
import { useSelector } from "react-redux";
export const useDetailsPanel = (type) => useSelector((state) => {
    if (state?.currentDashboard?.detailPanels) {
        return state?.currentDashboard?.detailPanels[type];
    }
    return {};
}, isEqual);
export const useDetailsPanels = () => useSelector((state) => state?.currentDashboard?.detailPanels, isEqual);
export const useCurrentWidgetFilterValues = (widget) => useSelector((state) => {
    if (!widget || !state?.currentDashboard?.currentWidgetFilterValues) {
        return {};
    }
    return state?.currentDashboard?.currentWidgetFilterValues[widget];
}, isEqual);
export const useCffChangeModal = () => useSelector((state) => state?.currentDashboard?.cffChangeModal, isEqual);
